import { RemoteAccessPanel } from "~/features/console/RemoteAccessPanel";

/** Registry wrapper — the surface itself lives with the rest of the IDE feature. */
export function RemoteAccess() {
  return <RemoteAccessPanel />;
}
